import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DatePicker, { registerLocale } from 'react-datepicker';
import { ja } from 'date-fns/locale';
import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import ColorSF2 from '../styles/common/ColorSF2';

const CustomDatePicker = styled(DatePicker)`
  width: 100%;
  min-width: 150px;
  ${props => props.height && `height: ${props.height}px`};
  background-color: ${props => (props.error ? '#faa' : '#fff')};
  border: 1px solid ${ColorSF2.mediumGray};
  padding: 0px 4px;
`;

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      inputDate: (props.value && new Date(props.value)) || null,
    };
    this.params = {
      onSearch: (props && props.onSearch) || null,
      validation: (props && props.validation) || null,
    };
    registerLocale('ja', ja);
  }

  shouldComponentUpdate(props) {
    this.params = {
      onSearch: (props && props.onSearch) || null,
      validation: (props && props.validation) || null,
    };
    return true;
  }

  componentDidUpdate({ value: prevValue }) {
    const { value } = this.props;
    if (value !== prevValue && Date.parse(value)) {
      this.setState({ inputDate: new Date(value) });
    }
  }

  handleChange(inputDate) {
    const { onSearch, validation } = this.params;
    if (validation(inputDate)) {
      onSearch();
    } else {
      this.setState({ inputDate });
      onSearch(inputDate);
    }
  }

  render() {
    const { locale, error, hideTime, height } = this.props;
    const { inputDate } = this.state;
    const placeholderText = hideTime ? 'YYYY/MM/DD' : 'YYYY/MM/DD HH:mm';
    const dateFormat = hideTime ? 'yyyy/MM/dd' : 'yyyy/MM/dd HH:mm';
    return (
      <CustomDatePicker
        locale={locale}
        selected={inputDate}
        placeholderText={placeholderText}
        dateFormat={dateFormat}
        onChange={this.handleChange}
        error={error}
        showTimeInput={!hideTime}
        height={height}
      />
    );
  }
}

Calendar.propTypes = {
  locale: PropTypes.string.isRequired, // TODO warning出る
  value: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  error: PropTypes.bool,
  validation: PropTypes.func,
  hideTime: PropTypes.bool,
  height: PropTypes.number,
};

Calendar.defaultProps = {
  validation: () => false,
  error: false,
  hideTime: false,
  height: undefined,
};

const mapStateToProps = state => ({
  locale: state.main.locale,
});

export default connect(mapStateToProps)(Calendar);
